import CheckoutDiscountLink from "../pages/CheckoutDiscountLink";
import DepositsTracking from "../pages/Deposits";
import Kanban from "../pages/Kanban";
import Leads from "../pages/Leads";
import TrackLead from "../pages/TrackLead";
import PaypalDiscountLink from "../pages/PayaplDiscountLink";
import UsersTracking from "../pages/UsersTracking";

const SalesRoutes = [
  {
    path: "/sales/home",
    exact: true,
    element: Leads,
  },
   {
    path: "/sales/kanban",
    exact: true,
    element: Kanban,
  },
   {
    path: "/sales/track-lead",
    exact: true,
    element: TrackLead,
  },
  {
    path: "/sales/user-tracking",
    exact: true,
    element: UsersTracking,
  },
  {
    path: "/sales/deposits",
    exact: true,
    element: DepositsTracking,
  },
  {
    path: "/sales/checkout-discount-links",
    exact: true,
    element: CheckoutDiscountLink,
  },
  {
    path: "/sales/paypal-discount-links",
    exact: true,
    element: PaypalDiscountLink,
  },
];

export default SalesRoutes;
